module.exports = "/images/info.png?8d883a7eca851451c9943a7be020da05";